
    import './styles.scoped.css';
    export default {
  "upload-button": "awsui_upload-button_4xu1k_1vhod_181",
  "upload-input": "awsui_upload-input_4xu1k_1vhod_182",
  "file-input-container": "awsui_file-input-container_4xu1k_1vhod_186",
  "force-focus-outline": "awsui_force-focus-outline_4xu1k_1vhod_195"
};
  